/**
 * MultiCottage Product Card template
 * @param {object} datas
 * @param {string} datas.title
 * @param {string|number} datas.number
 * @param {object} datas.participants
 * @param {string|number} datas.participants.senior
 * @param {string|number} datas.participants.adult
 * @param {string|number} datas.participants.child
 * @param {string|number} datas.participants.pet
 * @param {string|number} datas.participants.ages
 * @return {string} - Formatted HTML
*/

const cartoucheMultiCottageProduct = function (datas) {
  const hasParticipants = typeof datas.participants !== 'undefined';
  const {
    addCottageTitleFilled
  } = GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE;
  const {
    participants_labelSenior,
    participants_labelSeniors,
    participants_labeladult,
    participants_labelAdults,
    participants_labelchild,
    participants_labelChildren,
    participants_labelpet,
    participants_labelPets
  } = SEARCH_SCRIPTS.WORDING_SEARCH;
  let htmlParticipants = '';
  if (hasParticipants) {
    const {
      senior,
      adult,
      pet,
      ages
    } = datas.participants;
    let {
      child
    } = datas.participants;

    if (ages) {
      child = datas.participants.ages.length;
    }

    htmlParticipants = hasParticipants ? (typeof senior !== 'undefined' && senior !== 0 ? senior + '&nbsp;' + (senior === 1 ? participants_labelSenior : participants_labelSeniors) : '') + (typeof adult !== 'undefined' && adult !== 0 ? (typeof senior !== 'undefined' && senior === 0 ? '' : ', ') + adult + '&nbsp;' + (adult === 1 ? participants_labeladult : participants_labelAdults) : '') + (typeof child !== 'undefined' && child !== 0 ? ', ' + child + '&nbsp;' +  (child === 1 ? participants_labelchild : participants_labelChildren) : '' ) + (typeof pet !== 'undefined' && pet !== 0 ? ', ' + pet + '&nbsp;' +  (pet === 1 ? participants_labelpet : participants_labelPets) : '') : '';
  }

  return `
  <div class="cartMultiProductBlock">
    <div class="cartMultiProduct">
      <div class="cartMultiProduct-icon${!hasParticipants ? ' green' : ''}">
        ${hasParticipants ? `<i class="icon icon-arrow-top"></i><span>${datas.number}</span>` : '<i class="icon icon-check"></i>'}
      </div>
      <div class="cartMultiProduct-texts">
        <div class="cartMultiProduct-title">${!hasParticipants ? addCottageTitleFilled : datas.title}</div>
        <div class="cartMultiProduct-participants">
          ${htmlParticipants}
        </div>
      </div>
    </div>
  </div>`;
};

export { cartoucheMultiCottageProduct };